import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { MaintenanceMessageDto } from '../models/MaintenanceMessageDto'


@Injectable()
export class MaintenanceMessageService {
  constructor(private readonly httpService: HttpService) {}
// 
  // GET method to fetch the maintenance message
  getmaintenancemessage(): Observable<MaintenanceMessageDto> {
    return this.httpService.get(APIEndpoints.getmaintenancemessage);
  }

  // POST method to update the maintenance message
  addmaintenancemessage(message: MaintenanceMessageDto): Observable<void> {
    return this.httpService.post(
      APIEndpoints.addmaintenancemessage, 
      message
    );
  }
}